import { render, staticRenderFns } from "./Regulaminy.vue?vue&type=template&id=246a26cc"
import script from "./Regulaminy.vue?vue&type=script&lang=js"
export * from "./Regulaminy.vue?vue&type=script&lang=js"
import style0 from "./Regulaminy.vue?vue&type=style&index=0&id=246a26cc&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports